import { QuoteContainer } from './style'

export default function Quote() {
  return <QuoteContainer>Dilapidated and lost...</QuoteContainer>
}
